module.exports = __webpack_public_path__ + "img/gameart.938181d0.svg";